import { useState, useEffect } from 'react';
import useIntersectionObserver from 'hooks/useIntersectionObserver';

const TypeReveal = ({
  text,
  speed = 75,
  startDelay = 0,
  retriggerOnScroll = false,
  threshold = 0.5, // How much needs to be visible before triggering
  className,
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [index, setIndex] = useState(0);
  const { ref, isIntersecting } = useIntersectionObserver({
    threshold,
    once: !retriggerOnScroll, // If we only want to trigger once, stop observing
  });

  // Reset typing when it becomes visible (if retrigger is enabled)
  useEffect(() => {
    if (isIntersecting && retriggerOnScroll) {
      setDisplayedText('');
      setIndex(0);
    }
  }, [isIntersecting, retriggerOnScroll]);

  // Handle the typing animation
  useEffect(() => {
    if (isIntersecting && index < text.length) {
      const timeout = setTimeout(
        () => {
          setDisplayedText((prev) => prev + text[index]);
          setIndex((prev) => prev + 1);
        },
        index === 0 ? startDelay : speed,
      ); // add start delay only on first char

      return () => clearTimeout(timeout);
    }
  }, [isIntersecting, index, text, speed, startDelay]);

  return (
    <span ref={ref} className={className}>
      {displayedText}
    </span>
  );
};

export default TypeReveal;
